import webContextProvider from "../../../../../providers/webContextProvider";

export default () => {
  const { platform, storeId } = webContextProvider();

  return `${platform} ${storeId}`;
};
